import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "mobile-sd"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "text-line pt-6"
};
const _hoisted_4 = {
  class: "text-line"
};
const _hoisted_5 = {
  class: "running-job-list pt-3 pb-3"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "progress"
};
const _hoisted_8 = {
  key: 1,
  class: "task-in-queue"
};
const _hoisted_9 = {
  class: "finish-job-list"
};
const _hoisted_10 = {
  key: 0,
  class: "failed"
};
const _hoisted_11 = {
  class: "opt"
};
const _hoisted_12 = {
  key: 1,
  class: "job-item"
};
const _hoisted_13 = {
  class: "remove"
};
const _hoisted_14 = ["data-clipboard-text"];
import { onMounted, onUnmounted, ref } from "vue";
import { Delete } from "@element-plus/icons-vue";
import { httpGet, httpPost } from "@/utils/http";
import Clipboard from "clipboard";
import { checkSession, getClientId, getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import { getSessionId } from "@/store/session";
import { showConfirmDialog, showDialog, showFailToast, showImagePreview, showNotify, showSuccessToast, showToast } from "vant";
import { showLoginDialog } from "@/utils/libs";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'ImageSd',
  setup(__props) {
    const listBoxHeight = ref(window.innerHeight - 40);
    const mjBoxHeight = ref(window.innerHeight - 150);
    const isLogin = ref(false);
    const activeColspan = ref([""]);
    window.onresize = () => {
      listBoxHeight.value = window.innerHeight - 40;
      mjBoxHeight.value = window.innerHeight - 150;
    };
    const samplers = ref([{
      text: "Euler a",
      value: "Euler a"
    }, {
      text: "DPM++ 2S a Karras",
      value: "DPM++ 2S a Karras"
    }, {
      text: "DPM++ 2M Karras",
      value: "DPM++ 2M Karras"
    }, {
      text: "DPM++ 2M SDE Karras",
      value: "DPM++ 2M SDE Karras"
    }, {
      text: "DPM++ 2M Karras",
      value: "DPM++ 2M Karras"
    }, {
      text: "DPM++ 3M SDE Karras",
      value: "DPM++ 3M SDE Karras"
    }]);
    const showSamplerPicker = ref(false);
    const upscaleAlgArr = ref([{
      text: "Latent",
      value: "Latent"
    }, {
      text: "ESRGAN_4x",
      value: "ESRGAN_4x"
    }, {
      text: "ESRGAN 4x+",
      value: "ESRGAN 4x+"
    }, {
      text: "SwinIR_4x",
      value: "SwinIR_4x"
    }, {
      text: "LDSR",
      value: "LDSR"
    }]);
    const showUpscalePicker = ref(false);
    const params = ref({
      client_id: getClientId(),
      width: 1024,
      height: 1024,
      sampler: samplers.value[0].value,
      seed: -1,
      steps: 20,
      cfg_scale: 7,
      hd_fix: false,
      hd_redraw_rate: 0.7,
      hd_scale: 2,
      hd_scale_alg: upscaleAlgArr.value[0].value,
      hd_steps: 0,
      prompt: "",
      neg_prompt: "nsfw, paintings,low quality,easynegative,ng_deepnegative ,lowres,bad anatomy,bad hands,bad feet"
    });
    const runningJobs = ref([]);
    const finishedJobs = ref([]);
    const router = useRouter();
    // 检查是否有画同款的参数
    const _params = router.currentRoute.value.params["copyParams"];
    if (_params) {
      params.value = JSON.parse(_params);
    }
    const power = ref(0);
    const sdPower = ref(0); // 画一张 SD 图片消耗算力

    const userId = ref(0);
    const store = useSharedStore();
    const clipboard = ref(null);
    const prompt = ref("");
    onMounted(() => {
      initData();
      clipboard.value = new Clipboard(".copy-prompt-sd");
      clipboard.value.on("success", () => {
        showNotify({
          type: "success",
          message: "复制成功",
          duration: 1000
        });
      });
      clipboard.value.on("error", () => {
        showNotify({
          type: "danger",
          message: "复制失败",
          duration: 2000
        });
      });
      getSystemInfo().then(res => {
        sdPower.value = res.data.sd_power;
        params.value.neg_prompt = res.data.sd_neg_prompt;
      }).catch(e => {
        showNotify({
          type: "danger",
          message: "获取系统配置失败：" + e.message
        });
      });
      store.addMessageHandler("sd", data => {
        if (data.channel !== "sd" || data.clientId !== getClientId()) {
          return;
        }
        if (data.body === "FINISH" || data.body === "FAIL") {
          page.value = 1;
          fetchFinishJobs(1);
        }
        fetchRunningJobs();
      });
    });
    onUnmounted(() => {
      clipboard.value.destroy();
      store.removeMessageHandler("sd");
    });
    const initData = () => {
      checkSession().then(user => {
        power.value = user["power"];
        userId.value = user.id;
        isLogin.value = true;
        fetchRunningJobs();
        fetchFinishJobs(1);
      }).catch(() => {
        loading.value = false;
      });
    };
    const fetchRunningJobs = () => {
      // 获取运行中的任务
      httpGet(`/api/sd/jobs?finish=0`).then(res => {
        const jobs = res.data.items;
        const _jobs = [];
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].progress === -1) {
            showNotify({
              message: `任务ID：${jobs[i]["task_id"]} 原因：${jobs[i]["err_msg"]}`,
              type: "danger"
            });
            power.value += sdPower.value;
            continue;
          }
          _jobs.push(jobs[i]);
        }
        runningJobs.value = _jobs;
      }).catch(e => {
        showNotify({
          type: "danger",
          message: "获取任务失败：" + e.message
        });
      });
    };
    const loading = ref(false);
    const finished = ref(false);
    const error = ref(false);
    const page = ref(0);
    const pageSize = ref(10);
    // 获取已完成的任务
    const fetchFinishJobs = page => {
      loading.value = true;
      httpGet(`/api/sd/jobs?finish=1&page=${page}&page_size=${pageSize.value}`).then(res => {
        const jobs = res.data.items;
        if (jobs.length < pageSize.value) {
          finished.value = true;
        }
        const _jobs = [];
        for (let i = 0; i < jobs.length; i++) {
          if (jobs[i].progress === -1) {
            jobs[i]["thumb_url"] = jobs[i]["img_url"] + "?imageView2/1/w/480/h/600/q/75";
          }
          _jobs.push(jobs[i]);
        }
        if (page === 1) {
          finishedJobs.value = _jobs;
        } else {
          finishedJobs.value = finishedJobs.value.concat(_jobs);
        }
        loading.value = false;
      }).catch(e => {
        loading.value = false;
        showNotify({
          type: "danger",
          message: "获取任务失败：" + e.message
        });
      });
    };
    const onLoad = () => {
      page.value += 1;
      fetchFinishJobs(page.value);
    };

    // 创建绘图任务
    const promptRef = ref(null);
    const generate = () => {
      if (!isLogin.value) {
        return showLoginDialog(router);
      }
      if (params.value.prompt === "") {
        promptRef.value.focus();
        return showToast("请输入绘画提示词！");
      }
      if (!params.value.seed) {
        params.value.seed = -1;
      }
      params.value.session_id = getSessionId();
      httpPost("/sd/image", params.value).then(() => {
        showSuccessToast("绘画任务推送成功，请耐心等待任务执行...");
        power.value -= sdPower.value;
        fetchRunningJobs();
      }).catch(e => {
        showFailToast("任务推送失败：" + e.message);
      });
    };
    const showPrompt = item => {
      prompt.value = item.prompt;
      showConfirmDialog({
        title: "绘画提示词",
        message: item.prompt,
        confirmButtonText: "复制",
        cancelButtonText: "关闭"
      }).then(() => {
        document.querySelector("#copy-btn-sd").click();
      }).catch(() => {});
    };
    const showErrMsg = item => {
      showDialog({
        title: "错误详情",
        message: item["err_msg"]
      }).then(() => {
        // on close
      });
    };
    const removeImage = (event, item) => {
      event.stopPropagation();
      showConfirmDialog({
        title: "标题",
        message: "此操作将会删除任务和图片，继续操作码?"
      }).then(() => {
        httpGet("/sd/remove", {
          id: item.id,
          user_id: item.user
        }).then(() => {
          showSuccessToast("任务删除成功");
          fetchFinishJobs(1);
        }).catch(e => {
          showFailToast("任务删除失败：" + e.message);
        });
      }).catch(() => {
        showToast("您取消了操作");
      });
    };

    // 发布图片到作品墙
    const publishImage = (event, item, action) => {
      event.stopPropagation();
      let text = "图片发布";
      if (action === false) {
        text = "取消发布";
      }
      httpGet("/sd/publish", {
        id: item.id,
        action: action,
        user_id: item.user
      }).then(() => {
        showSuccessToast(text + "成功");
        item.publish = action;
      }).catch(e => {
        showFailToast(text + "失败：" + e.message);
      });
    };
    const imageView = item => {
      showImagePreview([item["img_url"]]);
    };
    const samplerConfirm = item => {
      params.value.sampler = item.selectedOptions[0].text;
      showSamplerPicker.value = false;
    };
    const upscaleConfirm = item => {
      params.value.hd_scale_alg = item.selectedOptions[0].text;
      showUpscalePicker.value = false;
    };
    const showInfo = message => {
      showDialog({
        title: "参数说明",
        message: message
      }).then(() => {
        // on close
      });
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_el_input = _resolveComponent("el-input");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_switch = _resolveComponent("van-switch");
      const _component_van_slider = _resolveComponent("van-slider");
      const _component_van_collapse_item = _resolveComponent("van-collapse-item");
      const _component_van_collapse = _resolveComponent("van-collapse");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_empty = _resolveComponent("van-empty");
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_circle = _resolveComponent("van-circle");
      const _component_van_grid_item = _resolveComponent("van-grid-item");
      const _component_van_grid = _resolveComponent("van-grid");
      const _component_van_loading = _resolveComponent("van-loading");
      const _component_el_button = _resolveComponent("el-button");
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_form, {
        onSubmit: generate
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_van_field, {
            modelValue: params.value.sampler,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.sampler = $event),
            "is-link": "",
            readonly: "",
            label: "采样方法",
            placeholder: "选择采样方法",
            onClick: _cache[1] || (_cache[1] = $event => showSamplerPicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showSamplerPicker.value,
            "onUpdate:show": _cache[3] || (_cache[3] = $event => showSamplerPicker.value = $event),
            position: "bottom",
            teleport: "#app"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: samplers.value,
              onCancel: _cache[2] || (_cache[2] = $event => showSamplerPicker.value = false),
              onConfirm: samplerConfirm
            }, null, 8, ["columns"])]),
            _: 1
          }, 8, ["show"])]), _createVNode(_component_van_field, {
            label: "图片尺寸"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_row, {
              gutter: "20"
            }, {
              default: _withCtx(() => [_createVNode(_component_van_col, {
                span: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.value.width,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => params.value.width = $event),
                  size: "small",
                  placeholder: "宽"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "12"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: params.value.height,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => params.value.height = $event),
                  size: "small",
                  placeholder: "高"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_van_field, {
            modelValue: params.value.steps,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => params.value.steps = $event),
            modelModifiers: {
              number: true
            },
            label: "迭代步数",
            placeholder: ""
          }, {
            "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
              name: "info-o",
              onClick: _cache[6] || (_cache[6] = $event => showInfo('值越大则代表细节越多，同时也意味着出图速度越慢，一般推荐20-30'))
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: params.value.cfg_scale,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => params.value.cfg_scale = $event),
            modelModifiers: {
              number: true
            },
            label: "引导系数",
            placeholder: ""
          }, {
            "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
              name: "info-o",
              onClick: _cache[8] || (_cache[8] = $event => showInfo('提示词引导系数，图像在多大程度上服从提示词，较低值会产生更有创意的结果'))
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: params.value.seed,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => params.value.seed = $event),
            modelModifiers: {
              number: true
            },
            label: "随机因子",
            placeholder: ""
          }, {
            "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
              name: "info-o",
              onClick: _cache[10] || (_cache[10] = $event => showInfo('随机数种子，相同的种子会得到相同的结果，设置为 -1 则每次随机生成种子'))
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_van_field, {
            label: "高清修复"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_switch, {
              modelValue: params.value.hd_fix,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => params.value.hd_fix = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), params.value.hd_fix ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_van_field, {
            modelValue: params.value.hd_scale_alg,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => params.value.hd_scale_alg = $event),
            "is-link": "",
            readonly: "",
            label: "放大算法",
            placeholder: "选择放大算法",
            onClick: _cache[14] || (_cache[14] = $event => showUpscalePicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
            show: showUpscalePicker.value,
            "onUpdate:show": _cache[16] || (_cache[16] = $event => showUpscalePicker.value = $event),
            position: "bottom",
            teleport: "#app"
          }, {
            default: _withCtx(() => [_createVNode(_component_van_picker, {
              columns: upscaleAlgArr.value,
              onCancel: _cache[15] || (_cache[15] = $event => showUpscalePicker.value = false),
              onConfirm: upscaleConfirm
            }, null, 8, ["columns"])]),
            _: 1
          }, 8, ["show"])]), _createVNode(_component_van_field, {
            modelValue: params.value.hd_scale,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => params.value.hd_scale = $event),
            modelModifiers: {
              number: true
            },
            label: "放大倍数"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: params.value.hd_steps,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => params.value.hd_steps = $event),
            modelModifiers: {
              number: true
            },
            label: "迭代步数"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            label: "重绘幅度"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_slider, {
              modelValue: params.value.hd_redraw_rate,
              "onUpdate:modelValue": [_cache[19] || (_cache[19] = $event => params.value.hd_redraw_rate = $event), _cache[20] || (_cache[20] = $event => _unref(showToast)('当前值：' + params.value.hd_redraw_rate))],
              modelModifiers: {
                number: true
              },
              max: 1,
              step: 0.1
            }, null, 8, ["modelValue"])]),
            "right-icon": _withCtx(() => [_createVNode(_component_van_icon, {
              name: "info-o",
              onClick: _cache[21] || (_cache[21] = $event => showInfo('决定算法对图像内容的影响程度，较大的值将得到越有创意的图像'))
            })]),
            _: 1
          })])) : _createCommentVNode("", true), _createVNode(_component_van_field, {
            modelValue: params.value.prompt,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => params.value.prompt = $event),
            rows: "3",
            autosize: "",
            type: "textarea",
            placeholder: "请在此输入绘画提示词，系统会自动翻译中文提示词，高手请直接输入英文提示词"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_collapse, {
            modelValue: activeColspan.value,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => activeColspan.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_van_collapse_item, {
              title: "反向提示词",
              name: "neg_prompt"
            }, {
              default: _withCtx(() => [_createVNode(_component_van_field, {
                modelValue: params.value.neg_prompt,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => params.value.neg_prompt = $event),
                rows: "3",
                autosize: "",
                type: "textarea",
                placeholder: "不想出现在图片上的元素(例如：树，建筑)"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_tag, null, {
            default: _withCtx(() => [_createTextVNode("绘图消耗" + _toDisplayString(sdPower.value) + "算力，当前算力：" + _toDisplayString(power.value), 1)]),
            _: 1
          })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[27] || (_cache[27] = [_createTextVNode(" 立即生成 ")])),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }), _cache[35] || (_cache[35] = _createElementVNode("h3", null, "任务列表", -1)), _createElementVNode("div", _hoisted_5, [runningJobs.value.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
        "image-size": "80",
        description: "暂无记录"
      })) : (_openBlock(), _createBlock(_component_van_grid, {
        key: 1,
        gutter: 10,
        "column-num": 3
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runningJobs.value, item => {
          return _openBlock(), _createBlock(_component_van_grid_item, {
            key: item.id
          }, {
            default: _withCtx(() => [item.progress > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_van_image, {
              src: "/images/img-holder.png"
            }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_circle, {
              "current-rate": item.progress,
              "onUpdate:currentRate": $event => item.progress = $event,
              rate: item.progress,
              speed: 100,
              text: item.progress + '%',
              "stroke-width": 60,
              size: "90px"
            }, null, 8, ["current-rate", "onUpdate:currentRate", "rate", "text"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[28] || (_cache[28] = [_createElementVNode("span", {
              class: "icon"
            }, [_createElementVNode("i", {
              class: "iconfont icon-quick-start"
            })], -1), _createElementVNode("span", {
              class: "text"
            }, "排队中", -1)])))]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }))]), _cache[36] || (_cache[36] = _createElementVNode("h3", null, "创作记录", -1)), _createElementVNode("div", _hoisted_9, [finishedJobs.value.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        image: "https://fastly.jsdelivr.net/npm/@vant/assets/custom-empty-image.png",
        "image-size": "80",
        description: "暂无记录"
      })) : (_openBlock(), _createBlock(_component_van_list, {
        key: 1,
        error: error.value,
        "onUpdate:error": _cache[25] || (_cache[25] = $event => error.value = $event),
        loading: loading.value,
        "onUpdate:loading": _cache[26] || (_cache[26] = $event => loading.value = $event),
        finished: finished.value,
        "error-text": "请求失败，点击重新加载",
        "finished-text": "没有更多了",
        onLoad: onLoad
      }, {
        default: _withCtx(() => [_createVNode(_component_van_grid, {
          gutter: 10,
          "column-num": 2
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(finishedJobs.value, item => {
            return _openBlock(), _createBlock(_component_van_grid_item, {
              key: item.id
            }, {
              default: _withCtx(() => [item.progress === 101 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_cache[31] || (_cache[31] = _createElementVNode("div", {
                class: "title"
              }, "任务失败", -1)), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_button, {
                size: "small",
                onClick: $event => showErrMsg(item)
              }, {
                default: _withCtx(() => _cache[29] || (_cache[29] = [_createTextVNode("详情")])),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_van_button, {
                type: "danger",
                onClick: $event => removeImage($event, item),
                size: "small"
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [_createTextVNode("删除")])),
                _: 2
              }, 1032, ["onClick"])])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_van_image, {
                src: item['img_url'],
                class: _normalizeClass(item['can_opt'] ? '' : 'upscale'),
                "lazy-load": "",
                onClick: $event => imageView(item),
                fit: "cover"
              }, {
                loading: _withCtx(() => [_createVNode(_component_van_loading, {
                  type: "spinner",
                  size: "20"
                })]),
                _: 2
              }, 1032, ["src", "class", "onClick"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_button, {
                type: "danger",
                icon: _unref(Delete),
                onClick: $event => removeImage($event, item),
                circle: ""
              }, null, 8, ["icon", "onClick"]), item.publish ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "warning",
                onClick: $event => publishImage($event, item, false),
                circle: ""
              }, {
                default: _withCtx(() => _cache[32] || (_cache[32] = [_createElementVNode("i", {
                  class: "iconfont icon-cancel-share"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "success",
                onClick: $event => publishImage($event, item, true),
                circle: ""
              }, {
                default: _withCtx(() => _cache[33] || (_cache[33] = [_createElementVNode("i", {
                  class: "iconfont icon-share-bold"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])), _createVNode(_component_el_button, {
                type: "primary",
                onClick: $event => showPrompt(item),
                circle: ""
              }, {
                default: _withCtx(() => _cache[34] || (_cache[34] = [_createElementVNode("i", {
                  class: "iconfont icon-prompt"
                }, null, -1)])),
                _: 2
              }, 1032, ["onClick"])])]))]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["error", "loading", "finished"]))]), _createElementVNode("button", {
        style: {
          "display": "none"
        },
        class: "copy-prompt-sd",
        "data-clipboard-text": prompt.value,
        id: "copy-btn-sd"
      }, "复制", 8, _hoisted_14)]);
    };
  }
};